import { useLang, LANGS } from "../i18n";

// Sélecteur de langue : 4 pastilles ES / FR / AR / RU.
export const LangSwitcher = ({ tone = "light", className = "" }) => {
  const { lang, setLang, t } = useLang();
  const idle = tone === "light" ? "text-[#F5EDE3]/45 hover:text-[#F5EDE3]" : "text-[#2B1E16]/45 hover:text-[#2B1E16]";

  return (
    <div
      data-testid="lang-switcher"
      role="group"
      aria-label={t.nav.lang}
      className={`flex items-center gap-1 ${className}`}
    >
      {LANGS.map((l, i) => (
        <span key={l.code} className="flex items-center">
          {i > 0 && <span className="mx-1 text-[10px] text-[#D9B98A]/30">·</span>}
          <button
            type="button"
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            aria-label={l.name}
            aria-current={lang === l.code}
            className={`font-sans text-[10px] uppercase tracking-[0.2em] transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B98A] ${
              lang === l.code ? "text-[#D9B98A]" : idle
            }`}
          >
            {l.label}
          </button>
        </span>
      ))}
    </div>
  );
};
